import React from 'react';
import { render } from 'react-dom';
import { withLocalState } from 'pyradux';

import configureStore from './state/store/configureStore';
import reducer from './state/reducers';
import App from './AppView';

import authSagas from './state/sagas/auth.sagas';

require('../styles/_index.less');

const withLocalStateOptions = {
  createStore: configureStore,
  sagas: [authSagas],
  reducer
};
const Root = withLocalState(withLocalStateOptions, App);

render(
  <Root />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/app/index.js